export const normalizeCompanyId = (value) => {
  if (value == null || value === '') return undefined
  const numeric = Number(value)
  return Number.isNaN(numeric) ? value : numeric
}

export const areCompanyIdsEqual = (a, b) => a != null && b != null && String(a) === String(b)

export const sortCompaniesByName = (companies = []) =>
  [...companies].sort((a, b) => (a.nomeFantasia || '').localeCompare(b.nomeFantasia || '', 'pt-BR'))
